import { withParams } from 'vuelidate';
export default () => withParams({ type: 'isTrue	' }, value => {
	if (typeof value === 'undefined' || value === null || value === '') {
		return true;
	}
	return value === true;
});
